export function stepPlayback(input) {
    const { prevState, state, prevTime, transportTime, clipChanged } = input;
    switch (state) {
        case 'playing': {
            // Fresh entry: was not playing before, or the clip switched mid-play.
            const resume = prevState !== 'playing' || clipChanged;
            return { command: 'ensure-playing', resume, flushTime: false };
        }
        case 'paused': {
            // Flush only on the playing → paused edge.
            const flushTime = prevState === 'playing';
            // Seek when the scrub position changed: on a scrub, and on entry from the
            // 'stopped' sentinel 0 to another position.
            const seeked = transportTime !== prevTime;
            const command = seeked ? 'seek' : 'hold-paused';
            return { command, resume: false, flushTime };
        }
        case 'stopped': {
            // Only emit stop-and-restore on the first stopped frame (transition
            // edge). Subsequent stopped frames are no-ops to avoid double-restore.
            if (prevState !== 'stopped') {
                return { command: 'stop-and-restore', resume: false, flushTime: false };
            }
            return { command: 'none', resume: false, flushTime: false };
        }
    }
}
//# sourceMappingURL=stepPlayback.js.map